import { Component, Input, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl, FormControlDirective, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { AutoCompletionService, AutoCompletionType } from '../../util/id-autocompletion.service';

@Component({
    selector: 'app-autocomplete-form-field',
    templateUrl: './autocomplete-form-field.component.html',
    styleUrls: ['./autocomplete-form-field.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: AutocompleteFormFieldComponent,
        multi: true
    }]
})
export class AutocompleteFormFieldComponent implements OnInit, ControlValueAccessor {
    @Input() placeholder: string = 'MANAGE_USER.USER_ID';
    @Input() autocompletionType: AutoCompletionType;
    @Input() formControl: UntypedFormControl;

    @ViewChild(FormControlDirective, { static: true })

    formControlDirective: FormControlDirective;
    filterOptions: WritableSignal<string[]> = signal([]);

    constructor(public autocomplete: AutoCompletionService) { }

    get control() {
        return this.formControl;
    }

    ngOnInit(): void {
        this.control.setValidators(this.getValidator());
    }

    onValueChangesInput(event: Event) {
        this.onValueChanges((<HTMLInputElement>event.target).value);
    }

    onValueChanges(value: string) {
        const checkValue = this.control.value;
        setTimeout(() => {
            if (checkValue === this.control.value) {
                this.filterOptions.set(this.autocomplete.getAutoCompletionArray(this.autocompletionType, value));
            }
        }, 150);
    }

    writeValue(obj: any): void {
        this.formControlDirective.valueAccessor.writeValue(obj);
    }
    registerOnTouched(fn: any): void {
        this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }
    registerOnChange(fn: any): void {
        this.formControlDirective.valueAccessor.registerOnChange(fn);
    }
    setDisabledState(isDisabled: boolean): void {
        this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
    }

    private getValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return !!this.filterOptions()?.find(option => control.value === option) ? null : { 'option': false };
        };
    }
}
